import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { IKundenArtsQueryShapes, KundenArtsQueryFilterConfig } from 'fa-kt.types';
import { KundenArtsService } from '../service';

@Component({
  selector: 'fa-kt-kunden-arts-filter',
  templateUrl: './kunden-arts-filter.component.html',
  styleUrls: ['./kunden-arts-filter.component.css'],
})
export class KundenArtsFilterComponent {
  readonly subscriptions: Subscription[] = [];

  KundenArtsFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public kundenArts: KundenArtsService,
  ) {
    this.KundenArtsFilterConfig = KundenArtsQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.kundenArts.shapes$.subscribe((shapes: IKundenArtsQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.KundenArtsFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.KundenArtsFilterConfig[index].selections = shapes;
  }
}
